<script>
  /* Executable code section of the program */
  //Tools importation
  import { onAuthStateChanged } from "firebase/auth";
  import { onMount } from "svelte";
  import { auth, getOneDocument, getSpecificDocuments } from "../apis/APIS";
  import {
    currentEvent,
    temporalData,
    userLocalData,
    userRealTime,
  } from "../apis/storage";

  //Component importation
  import Loader from "../components/Loader.svelte";
  import { navigate } from "svelte-routing";

  //Auxiliary variables
  let poll;
  let isloadPage = false;
  let pathname;
  let myChart

  //Data variables section
  let options = [];
  $: optionsSelected = [];
  let totalResponses

  //Function to update answer polls
  const refreshAnswers = async () => {
    let newArray = []
    //Get poll information
    poll = await getOneDocument("polls", pathname);
    poll.options.forEach((element,index) => {
      newArray.push(element.votes.length)
    }); 
    optionsSelected = newArray
    updateChart(optionsSelected)
    totalResponses = optionsSelected.reduce((sum, value) => sum + value, 0);
    
  };
  //Function to update data
  const updateChart = (newData) =>{
    
    myChart.data.datasets[0].data = newData;
    myChart.update();
  }

 

  //Logged-in session verification
  //Initial function execution
  onMount(async () => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        
    window.scrollTo({ top: 0, behavior: "smooth" });
        //Get current user
        $userLocalData = getSpecificDocuments("users","email",user.email)

        //Get url name
        pathname = window.location.pathname.split("/")[2];

        setInterval(refreshAnswers,2500)

        //Get poll information
        poll = await getOneDocument("polls", pathname);
        poll.options.forEach((element) => {
          options.push(element.optionTittle);
          optionsSelected.push(element.votes.length);
        });
         //Function to porcent data 
        totalResponses = optionsSelected.reduce((sum, value) => sum + value, 0);
        

        setTimeout(() => {
          isloadPage = true;
          setTimeout(() => {
            const ctx = document.getElementById("myChart");
            //Data settings section
            myChart = new Chart(ctx, {
              type: "bar",
              data: {
                labels: options,
                datasets: [
                  {
                    data: optionsSelected,
                    backgroundColor: "#ed2824",
                    borderColor: "white",
                    borderWidth: 1.5,
                    barThickness: 50,
                  },
                ],
              },
              options: {
                plugins: {
                  legend: {
                    display:false,
                    labels: {
                      color: "white", // Legend text color
                      font: {
                        size: 15,
                      },
                    },
                  },
                },
                scales: {
                  x: {
                    ticks: {
                      color: "white", // X-axis numbers in white
                      font: {
                        size: 20,
                      },
                    },
                    grid: {
                      color: "rgba(255, 255, 255, 0.2)", // Grid lines in white (semi-transparent)
                    },
                  },
                  y: {
                    ticks: {
                      color: "white", // Y-axis numbers in white
                      font: { size: 15},
                        callback: function (value) {                          
                          const percentage = totalResponses ? (value / totalResponses) * 100 : 0;
                          return `${percentage.toFixed(0)}%`;
                      },
                    },
                    grid: {
                      color: "rgba(255, 255, 255, 0.2)", // Grid lines in white (semi-transparent)
                    },
                  },
                },
              },
            });
          }, 50);
        }, 1500);
      } else {
        navigate("/");
      }
    });
  });
  /* End of the section */
</script>

<!-- Section to place the HTML code -->
{#if isloadPage}
  <section class="principalContainer">
    <div class="dataContainer">
      <h2>{poll.question}</h2>
      <canvas id="myChart" width="300" height="200"></canvas>
    </div>
    <div class="logoContainer">
      <img
        src="https://res.cloudinary.com/dgx8kh6hn/image/upload/v1740501352/LogoWhite_ti8e1y.png"
        alt="Logo"
        class="imgLogo"
      />
    </div>
  </section>
{:else}
  <Loader />
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  .principalContainer {
    width: 100%;
    height: 100dvh;
    background-color: #222222;
  }
  /* Show data styles */
  .dataContainer {
    width: 100%;
    height: 85%;
    max-height: 90dvh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 30px;
  }
  canvas {
    max-width: 50%;
    height: 10dvh;
    margin: 10px 0;
  }
  h2 {
    color: white;
  }

  /* Logo styles */
  .logoContainer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 15%;
    padding: 10px;
  }
  img {
    width: 20%;
    height: auto;
  }
  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
  }
  /* End of the section */
</style>
